import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { DropCountdown } from "./DropCountdown";

const HERO_IMG = "https://customer-assets-lqy194kg.emergentagent.net/job_braid-collections/artifacts/owec676b_DSC04993_Original.webp";

const ease = [0.22, 1, 0.36, 1];

const Line = ({ children, delay }) => (
  <span className="block overflow-hidden">
    <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 1.05, ease, delay }}>
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "24%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.14]);

  return (
    <section ref={ref} data-testid="hero" className="relative h-screen w-full overflow-hidden flex flex-col justify-end bg-[#0B0E14]">
      <motion.div style={{ y, scale }} className="absolute inset-0 -z-0">
        <img src={HERO_IMG} alt="Funky Apparel — his fight, our fight" className="w-full h-[112%] object-cover opacity-95 scale-125 origin-left" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-[#0B0E14]/45 to-[#0B0E14]/25" />
      </motion.div>

      <div className="relative z-10 w-full mx-auto px-4 sm:px-8 md:px-12 pb-14 md:pb-20">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4, duration: 1 }}
          className="label text-[#EDEEF1] mb-5 flex items-center gap-3">
          <span className="bg-volt text-white px-2 py-1">FUNKY APPAREL</span> IN SUPPORT OF GARRISON STEPHENS
        </motion.p>
        <h1 className="font-serif-display text-[#EDEEF1] text-6xl sm:text-7xl lg:text-8xl xl:text-[8.5rem] leading-[0.82] max-w-6xl">
          <Line delay={0.28}>Keep fighting.</Line>
          <Line delay={0.42}>Keep showing up.</Line>
          <Line delay={0.56}><span className="volt">Never back down.</span></Line>
        </h1>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.95, duration: 0.8, ease }}
          className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-6">
          <Link to="/shop" data-testid="hero-shop-cta"
            className="bg-volt text-white px-10 h-14 flex items-center label font-bold hover:bg-[#0B0E14] hover:text-[#EDEEF1] transition-colors duration-300">
            Shop the Drop
          </Link>
          <span className="flex items-center gap-2 label text-[#EDEEF1]">
            <ArrowDown className="w-4 h-4 animate-bounce" /> Scroll
          </span>
        </motion.div>

        <div className="mt-10 pt-8 border-t border-[#EDEEF1]/20">
          <DropCountdown light />
        </div>
      </div>
    </section>
  );
};
